import { SearchOutlined } from '@ant-design/icons';
import {
  Button,
  Divider,
  Dropdown,
  Input,
  MenuProps,
  Modal,
  Pagination,
  PaginationProps,
  Select,
  Space,
  Table,
  Typography,
} from 'antd';
import { ColumnsType } from 'antd/lib/table';
import { Loading } from 'components';
import GeneralHeader from 'components/common/GeneralHeader';
import useAuth from 'hooks/useAuth';
import useNotice from 'hooks/useNotice';
import debounce from 'lodash.debounce';
import { useCallback, useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import { useNavigate } from 'react-router-dom';
import {
  DELETE,
  EmployeeUsersProps,
  GET,
  POST,
  PUT,
  employment_contract,
  professional_status,
} from 'utils';
import { api } from 'utils/apiRoutes';
import instance from 'utils/axiosConfig';
import { setCookie } from 'utils/common_function';
import NESTEDROUTE from 'utils/router';

const { Text } = Typography;
type TemployeeUser = {
  fullName: string;
  email: string;
  adminNumber: string;
  jobTitle: string;
  department: string;
  userProfile: string;
  staffLeaveProfile: string;
  employeeContract: string;
  contractStart: string;
  contractEnd: string;
  contractStartReason: string;
  contractEndReason: string;
  proStatus: string;
  manager: string;
  action?: string;
  workTimeUnit: string;
  workshift?: string;
};
const EmployeeUsers = () => {
  const { successNotification } = useNotice();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);

  const [state, setState] = useState({
    searchDepartment: '',
    searchUserProfile: '',
    searchEmployeeContract: '',
    searchProfessionalStatus: '',
    is_archived: false,
    searchString: '',
    count: null,
    page: '1',
    currentPage: 1,
    page_size: '25',
    checkDelete: false,
  });
  const {
    checkDelete,
    searchString,
    page,
    page_size,
    count,
    currentPage,
    searchDepartment,
    searchUserProfile,
    searchEmployeeContract,
    searchProfessionalStatus,
    is_archived,
  } = state;

  const [modal, setModal] = useState({
    name: '',
    id: 0,
    open: false,
    open1: false,
  });

  const { name, id, open, open1 } = modal;

  const { user } = useAuth();
  const navigate = useNavigate();

  // const [_, setCookies] = useCookies(['access_token', 'refresh_token']);
  // const getListEmployee = async () => {
  //   return await instance.get(`${api.getEmployees}`);
  // };
  const onChangeInput = (event) => {
    updateSearchValue(event.currentTarget.value);
  };
  const updateSearchValue = useCallback(
    debounce((event) => {
      setState((pre) => ({
        ...pre,
        searchString: event,
        page: '1',
      }));
    }, 500),
    [],
  );
  const department = useQuery('get-department', async () => {
    return await instance.get(api.departmentList);
  })?.data?.data.map((item: object, index) => {
    return {
      value: item['id'],
      label: item['name'],
    };
  });

  useEffect(() => {
    GET(
      `${api.getEmployees}?${
        is_archived === true
          ? 'is_archived=true'
          : is_archived === false
          ? 'is_archived=false'
          : 'is_undefined=true'
      }${searchDepartment ? '&department_id=' + searchDepartment : ''}${
        searchUserProfile ? '&role=' + searchUserProfile : ''
      }${
        searchEmployeeContract
          ? '&employment_contract=' + searchEmployeeContract
          : ''
      }${
        searchProfessionalStatus
          ? '&professional_status=' + searchProfessionalStatus
          : ''
      }${page && '&page=' + page}${page_size && '&page_size=10'}${
        searchString && '&search=' + searchString
      }`,
    )
      .then((res) => {
        setData(res?.data?.results);
        setState((p) => ({
          ...p,
          count: res?.data?.count,
          currentPage: res?.data?.page,
        }));
      })
      .catch((err) => {
        console.log(err);
      });
  }, [
    checkDelete,
    searchDepartment,
    searchString,
    searchUserProfile,
    searchEmployeeContract,
    searchProfessionalStatus,
    page,
    is_archived,
    page_size,
  ]);
  const items: MenuProps['items'] =
    is_archived === true
      ? [
          {
            icon: (
              <img
                src={'/icons/history_icon.svg'}
                alt={'login'}
                width={20}
                height={20}
              />
            ),
            key: '1',
            label: 'Employee History',
          },
          {
            key: '2',
            label: 'Delete',
            icon: (
              <img
                src={'/icons/delete_icon.svg'}
                alt={'login'}
                width={20}
                height={20}
              />
            ),
          },
        ]
      : [
          {
            icon: (
              <img
                src={'/icons/login_user.svg'}
                alt={'login'}
                width={20}
                height={20}
              />
            ),
            key: '1',
            label: 'Sign in under user this account',
          },
          {
            key: '2',
            label: 'User Archive',
            icon: (
              <img
                src={'/icons/archive_icon.svg'}
                alt={'login'}
                width={20}
                height={20}
              />
            ),
          },
          {
            key: '3',
            label: 'Open work shift calendar',
            icon: (
              <img
                src={'/icons/calendar.svg'}
                alt={'login'}
                width={20}
                height={20}
              />
            ),
          },
          {
            key: '4',
            label: 'Open user profile',
            icon: (
              <img
                src={'/icons/persona_icon.svg'}
                alt={'login'}
                width={20}
                height={20}
              />
            ),
          },
          {
            key: '5',
            label: 'Open staff leave profile',
            icon: (
              <img
                src={'/icons/staff_icon.svg'}
                alt={'login'}
                width={20}
                height={20}
              />
            ),
          },
        ];

  async function loginAsOtherUser(id: number) {
    await POST(api.forceLogin, { user_id: id }).then((res) => {
      if (res.status === 200) {
        setCookie('access_token', res.data.access);
        localStorage.setItem('refresh', res.data.refresh);
        window.location.href = '/';
      }
    });
  }
  const archiveUser = async function (id: number | number[]) {
    setLoading(true);
    const res = await PUT(`${api.archiveUser}/?ids=${id}`);
    if (res.status === 204) {
      setLoading(false);
      successNotification('Moved successfully.');
    }
    setState((pre) => ({
      ...pre,
      checkDelete: !checkDelete,
      searchString: '',
      searchDepartment: '',
      searchUserProfile: '',
      searchEmployeeContract: '',
      searchProfessionalStatus: '',
    }));
  };
  const deleteUser = async (id: number | number[]) => {
    setLoading(true);
    const res = await DELETE(`${api.deleteUser}/?ids=${id}`);
    if (res.status === 204) {
      setModal((p) => ({ ...p, open: false }));
      successNotification('Delete successfully.');
    }
    setLoading(false);
    setState((pre) => ({
      ...pre,
      checkDelete: !checkDelete,
      searchString: '',
      searchDepartment: '',
      searchUserProfile: '',
      searchEmployeeContract: '',
      searchProfessionalStatus: '',
    }));
  };
  const rawData = data?.map((item: object) => {
    return {
      id: item['id'],
      fullName: item['first_name'] + ' ' + item['last_name'],
      email: item['email'],
      adminNumber: item['job_number'],
      jobTitle: item['job_title'],
      department: item['department__name'],
      managers:
        item['managers__first_name'] + ' ' + item['managers__last_name'],
      workshift: item['workshift_policy__name'],
      userProfile: item['role'],
      staffLeaveProfile: item['absence_policy__name'],
      employeeContract: item['contract__employment_contract'],
      contractStart: item['contract__contract_start_date'],
      contractEnd: item['contract__contract_end_date'],
      contractStartReason: item['contract__contract_start_reason'],
      contractEndReason: item['contract__contract_end_reason'],
      proStatus: item['contract__professional_status'],
      workshiftID: item['workshift_policy_id'],
      absenceID: item['absence_policy_id'],
    };
  });

  const rows = [
    'fullName',
    'adminNumber',
    'department',
    'managers',
    'workshift',
    'userProfile',
    'staffLeaveProfile',
    'employeeContract',
    'contractStart',
    'contractEnd',
    'contractStartReason',
    'contractEndReason',
    'proStatus',
    'jobTitle',
    'email',
  ];
  const onChangePagination = (pageNumber) => {
    setState((pre) => ({
      ...pre,
      page: pageNumber,
    }));
  };

  const employeeData = rawData?.map((item: EmployeeUsersProps, index) => {
    return {
      key: index,
      action: (
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <Dropdown
            menu={{
              items,
              style: { padding: '8px' },
              onClick: (e) => {
                switch (e.key) {
                  case '1':
                    user.id !== item.id && is_archived === true
                      ? navigate(NESTEDROUTE.employee_history, {
                          state: item.id,
                        })
                      : loginAsOtherUser(item['id']);
                    break;
                  case '2':
                    user.id !== item.id && is_archived === true
                      ? setModal((p) => ({
                          ...p,
                          name: item.fullName,
                          id: item['id'],
                          open: true,
                        }))
                      : setModal((p) => ({
                          ...p,
                          name: item.fullName,
                          id: item['id'],
                          open1: true,
                        }));
                    break;
                  case '3':
                    navigate(`/general_settings/workshift_calendar/detail`, {
                      state: {
                        id: item['workshiftID'],
                        name: item['workshift'],
                      },
                    });
                    break;
                  case '4':
                    navigate(
                      `/general_settings/employee_&_users/personal_data/${item.id}`,
                    );
                    break;
                  case '5':
                    navigate(NESTEDROUTE.staff_leave_profile_detail, {
                      state: {
                        id: item['absenceID'],
                        name: item['staffLeaveProfile'],
                      },
                    });

                    break;
                  default:
                    break;
                }
              },
            }}
            placement={'topLeft'}
          >
            <Button
              type={'text'}
              icon={
                <img
                  src={'/icons/3_dots.svg'}
                  alt={'icon'}
                  width={18}
                  height={18}
                />
              }
            />
          </Dropdown>
        </div>
      ),
      jobTitle: item['jobTitle'],
      fullName: item.fullName,
      email: item['email'],
      adminNumber: item.adminNumber,
      department: item.department,
      manager: item['managers'],
      workshift: item.workshift,
      userProfile: item['userProfile']
        ?.split('_')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' '),
      staffLeaveProfile: item['staffLeaveProfile'],
      employeeContract: employment_contract?.find((item1) => {
        return item['employeeContract'] === item1.value;
      })?.label,
      contractStart: item['contractStart'],
      contractEnd: item['contractEnd'],
      contractStartReason: item['contractStartReason']
        ?.split('_')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' '),
      contractEndReason: item['contractEndReason']
        ?.split('_')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' '),
      proStatus:
        item['proStatus'] === 'manager'
          ? 'Management'
          : item['proStatus']
              ?.split('_')
              .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
              .join(' '),
    };
  });

  const tableHeadRow: ColumnsType<TemployeeUser> = [
    {
      title: <p className="table_content_header">Action</p>,
      dataIndex: 'action',
      width: 150,
    },
    {
      title: <p className="table_content_header">Employee</p>,
      dataIndex: 'fullName',
      width: 200,
      render: (text) => <p className="table_content_row">{text}</p>,
    },
    {
      title: <p className="table_content_header">Email Address</p>,
      dataIndex: 'email',
      width: 250,
      render: (text) => <p className="table_content_row">{text}</p>,
    },
    {
      title: <p className="table_content_header">Administrative number</p>,
      dataIndex: 'adminNumber',
      width: 150,
      render: (text) => <p className="table_content_row">{text}</p>,
    },
    {
      title: <p className="table_content_header">Job title</p>,
      dataIndex: 'jobTitle',
      ellipsis: true,
      width: 100,
      render: (text) => <p className="table_content_row">{text}</p>,
    },
    {
      title: (
        <>
          <p
            className="table_content_header"
            style={{
              paddingLeft: 10,
              paddingBottom: '0.5rem',
              textAlign: 'left',
            }}
          >
            Department
          </p>
          <Select
            options={department}
            style={{
              width: 150,
              borderRadius: '0.125rem',
              border: '0.5px solid #407FDD',
            }}
            bordered={false}
            suffixIcon={
              <img alt={'icon'} src={'/icons/arrow_select.svg'} width={8} />
            }
            clearIcon={
              <div
                style={{
                  background: '#fafafa',
                }}
              >
                <img alt={'icon'} src={'/icons/close.svg'} width={8} />
              </div>
            }
            allowClear
            onChange={(e) =>
              setState((p) => ({
                ...p,
                searchDepartment: e,
                page: '1',
              }))
            }
          />
        </>
      ),
      dataIndex: 'department',
      width: 200,
      render: (text) => <p className="table_content_row">{text}</p>,
    },
    {
      title: <p className="table_content_header">Supervisor</p>,
      dataIndex: 'manager',
      width: 200,
      render: (text) => <p className="table_content_row">{text}</p>,
    },
    {
      title: <p className="table_content_header">Workshift</p>,
      dataIndex: 'workshift',
      width: 150,
      render: (text) => <p className="table_content_row">{text}</p>,
    },
    {
      title: (
        <>
          <p
            className="table_content_header"
            style={{ paddingBottom: '0.5rem' }}
          >
            User Profile
          </p>
          <Select
            options={[
              { value: 'employee', label: 'Employee' },
              { value: 'service_manager', label: 'Service Manager' },
              { value: 'department_manager', label: 'Department Manager' },
              { value: 'admin', label: 'Admin' },
            ]}
            allowClear
            style={{
              width: 150,
              borderRadius: '0.125rem',
              border: '0.5px solid #407FDD',
            }}
            clearIcon={
              <div
                style={{
                  background: '#fafafa',
                }}
              >
                <img alt={'icon'} src={'/icons/close.svg'} width={8} />
              </div>
            }
            bordered={false}
            suffixIcon={
              <img alt={'icon'} src={'/icons/arrow_select.svg'} width={8} />
            }
            onChange={(e) =>
              setState((p) => ({
                ...p,
                searchUserProfile: e,
                page: '1',
              }))
            }
          />
        </>
      ),
      dataIndex: 'userProfile',
      width: 200,
      render: (_) => <p className="table_content_row">{_.replace('_', ' ')}</p>,
    },
    {
      title: <p className="table_content_header">Staff Leave Profile</p>,
      dataIndex: 'staffLeaveProfile',
      width: 150,
      render: (text) => <p className="table_content_row">{text}</p>,
    },
    {
      title: (
        <>
          <p
            className="table_content_header"
            style={{ paddingBottom: '0.5rem' }}
          >
            Employment Contract
          </p>
          <Select
            options={employment_contract}
            style={{
              width: 150,
              borderRadius: '0.125rem',
              border: '0.5px solid #407FDD',
            }}
            allowClear
            clearIcon={
              <div
                style={{
                  background: '#fafafa',
                }}
              >
                <img alt={'icon'} src={'/icons/close.svg'} width={8} />
              </div>
            }
            bordered={false}
            suffixIcon={
              <img alt={'icon'} src={'/icons/arrow_select.svg'} width={8} />
            }
            onChange={(e) =>
              setState((p) => ({
                ...p,
                searchEmployeeContract: e,
                page: '1',
              }))
            }
          />
        </>
      ),
      dataIndex: 'employeeContract',
      width: 200,
      render: (text) => <p className="table_content_row">{text}</p>,
    },
    {
      title: <p className="table_content_header">Contract Start Date</p>,
      dataIndex: 'contractStart',
      width: 150,
      render: (text) => <p className="table_content_row">{text}</p>,
    },
    {
      title: <p className="table_content_header">Contract Start Reason</p>,
      dataIndex: 'contractStartReason',
      width: 150,
      render: (text) => <p className="table_content_row">{text}</p>,
    },
    {
      title: <p className="table_content_header">Contract End Date</p>,
      dataIndex: 'contractEnd',
      width: 150,
      render: (text) => <p className="table_content_row">{text}</p>,
    },
    {
      title: <p className="table_content_header">Contract End Reason</p>,
      dataIndex: 'contractEndReason',
      width: 150,
      render: (text) => <p className="table_content_row">{text}</p>,
    },
    {
      title: (
        <>
          <p
            className="table_content_header"
            style={{
              paddingBottom: '0.5rem',
              paddingLeft: 10,
              textAlign: 'left',
            }}
          >
            Professional Status
          </p>
          <Select
            options={professional_status}
            style={{
              width: 150,
              borderRadius: '0.125rem',
              border: '0.5px solid #407FDD',
            }}
            bordered={false}
            suffixIcon={
              <img alt={'icon'} src={'/icons/arrow_select.svg'} width={8} />
            }
            clearIcon={
              <div
                style={{
                  background: '#fafafa',
                }}
              >
                <img alt={'icon'} src={'/icons/close.svg'} width={8} />
              </div>
            }
            allowClear
            onChange={(e) =>
              setState((p) => ({
                ...p,
                searchProfessionalStatus: e,
                page: '1',
              }))
            }
          />
        </>
      ),
      dataIndex: 'proStatus',
      align: 'center',
      width: 200,
      render: (_) => <p className={'table_content_row'}>{_}</p>,
    },
  ];
  const itemRender: PaginationProps['itemRender'] = (
    _,
    type,
    originalElement,
  ) => {
    if (type === 'prev') {
      return <a className="mr-3">Previous</a>;
    }
    if (type === 'next') {
      return (
        <a className=" ml-3" style={{ fontSize: '12px' }}>
          Next
        </a>
      );
    }

    return originalElement;
  };
  if (loading) return <Loading />;
  return (
    <GeneralHeader
      icon={'/icons/ic_employee.svg'}
      pageTitle={'Employee & Users'}
      child={
        <div key={1}>
          <div style={{ marginTop: '10em' }}>
            <div
              style={{
                width: '100%',
                height: 'auto',
              }}
              className="employee_users_table staff_leave_footer"
            >
              <Space
                size={'middle'}
                style={{
                  margin: '18px 16px',
                  position: 'sticky',
                  top: 0,
                  gap: 30,
                }}
              >
                <img src="/icons/my_request_settings.svg" alt="settings" />
                <Text
                  style={{ fontSize: 14, fontWeight: 400, color: '#000000' }}
                >
                  {employeeData?.length > 0
                    ? `${employeeData?.length} items`
                    : '0 item'}
                </Text>
                <Select
                  bordered={false}
                  style={{
                    width: 150,
                    fontWeight: 'bold',
                  }}
                  options={[
                    {
                      value: false,
                      label: (
                        <strong className="table_content_option">
                          User Active
                        </strong>
                      ),
                    },
                    {
                      value: true,
                      label: (
                        <strong className="table_content_option">
                          User Archive
                        </strong>
                      ),
                    },
                    {
                      value: null,
                      label: (
                        <strong className="table_content_option">
                          Undefined User
                        </strong>
                      ),
                    },
                  ]}
                  className="custom-select"
                  suffixIcon={
                    <img alt={'icon'} src={'/icons/arrow_select.svg'} />
                  }
                  defaultValue={is_archived}
                  onChange={(e) => {
                    setState((p) => ({
                      ...p,
                      is_archived: e,
                      page: '1',
                    }));
                  }}
                />
                <Input
                  suffix={<SearchOutlined />}
                  placeholder={'Search'}
                  onChange={onChangeInput}
                  style={{ width: 240 }}
                />
              </Space>
              <Divider style={{ background: '#73A1E7', margin: 0 }} />

              {employeeData && (
                <Table
                  columns={tableHeadRow}
                  dataSource={employeeData}
                  className="config_table"
                  size={'large'}
                  pagination={false}
                  scroll={{ x: 1500, y: 'calc(100vh - 220px)' }}
                  locale={{
                    emptyText: (
                      <p style={{ float: 'left', color: '#000000' }}>No item</p>
                    ),
                  }}
                />
              )}
            </div>
          </div>
          {employeeData?.length > 0 && (
            <div className="is-flex is-justify-content-center is-align-content-center mt-2 staff_leave_footer">
              <Pagination
                showSizeChanger={false}
                itemRender={itemRender}
                defaultPageSize={10}
                onChange={onChangePagination}
                defaultCurrent={1}
                total={count}
                current={currentPage}
              />
            </div>
          )}

          <div className="request_modal1">
            <Modal
              closeIcon={null}
              title={null}
              footer={null}
              open={open1}
              onOk={() => setModal((p) => ({ ...p, open1: false }))}
              onCancel={() => setModal((p) => ({ ...p, open1: false }))}
              width={'400px'}
              style={{ top: '40%' }}
            >
              <div>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    marginBottom: -14,
                  }}
                >
                  <p
                    style={{
                      marginLeft: -4,
                      fontWeight: '500px',
                      marginTop: -8,
                      color: '#000000',
                    }}
                  >
                    Are you sure you want to move user “
                    <strong style={{ fontWeight: '500px', color: '#000' }}>
                      {name}
                    </strong>
                    ” turn into{' '}
                    <strong style={{ fontWeight: '600px', color: '#000' }}>
                      User Archive
                    </strong>
                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                      <p style={{ color: '#E02C2C' }}>Note: Can’t move back</p>
                      <p
                        style={{
                          marginLeft: 2,
                          color: '#E02C2C',
                          fontWeight: 600,
                        }}
                      >
                        User Active
                      </p>
                    </div>
                  </p>
                  <img
                    style={{
                      cursor: 'pointer',
                      marginBottom: 'auto',
                      marginTop: -4,
                      marginRight: -8,
                    }}
                    src="/icons/icon_close.svg"
                    alt="x"
                    onClick={() => setModal((p) => ({ ...p, open1: false }))}
                  />
                </div>
                <div style={{ height: '2px' }} />
                <div style={{ marginLeft: '160px' }}>
                  <Button
                    type={'primary'}
                    style={{
                      width: '84px',
                      height: '36px',
                      color: '#000000',
                      backgroundColor: '#FFFFFF',
                      boxShadow: 'none',
                    }}
                    onClick={() => setModal((p) => ({ ...p, open1: false }))}
                  >
                    CLOSE
                  </Button>

                  <Button
                    type={'primary'}
                    style={{
                      width: '96px',
                      height: '36px',
                      marginLeft: '12px',
                      color: '#FFFFFF',
                      backgroundColor: '#407FDD',
                      boxShadow: 'none',
                    }}
                    onClick={() => {
                      setModal((p) => ({ ...p, open1: false }));
                      archiveUser(id);
                    }}
                  >
                    CONFIRM
                  </Button>
                </div>
              </div>
            </Modal>
          </div>
          {/* <Modal
            title="Delete"
            open={open}
            onCancel={() => setModal((p) => ({ ...p, open: false }))}
            onOk={() => {
              deleteUser(id);
            }}
          >
            <p>
              Are you sure to delete '<strong>{name}</strong>'?
            </p>
          </Modal> */}
          <div className="delete_modal">
            <Modal
              closeIcon={null}
              title={null}
              footer={null}
              open={open}
              onOk={() => {
                deleteUser(id);
              }}
              onCancel={() => setModal((p) => ({ ...p, open: false }))}
              width={'400px'}
              style={{ top: '40%' }}
            >
              <div style={{ margin: -4 }}>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                  <p style={{ color: '#000', fontSize: '14px' }}>
                    Are you sure you want to delete user “
                    <strong>{name}</strong>”?
                  </p>
                  <img
                    style={{
                      cursor: 'pointer',
                      widows: '24px',
                      height: '24px',
                      marginLeft: 'auto',
                      marginBottom: 'auto',
                    }}
                    src="/icons/icon_close.svg"
                    alt="x"
                    onClick={() => setModal((p) => ({ ...p, open: false }))}
                  />
                </div>
                <div style={{ height: '10px' }}></div>
                <div style={{ marginLeft: '172px' }}>
                  <Button
                    type={'primary'}
                    style={{
                      width: '84px',
                      height: '36px',
                      color: '#000000',
                      backgroundColor: '#FFFFFF',
                      boxShadow: 'none',
                    }}
                    onClick={() => setModal((p) => ({ ...p, open: false }))}
                  >
                    CLOSE
                  </Button>
                  <Button
                    type={'primary'}
                    style={{
                      width: '84px',
                      height: '36px',
                      marginLeft: '12px',
                      color: '#FFFFFF',
                      backgroundColor: '#F86767',
                      boxShadow: 'none',
                    }}
                    onClick={() => {
                      deleteUser(id);
                    }}
                  >
                    DELETE
                  </Button>
                </div>
              </div>
            </Modal>
          </div>
        </div>
      }
    />
  );
};

export default EmployeeUsers;
